// extracted by mini-css-extract-plugin
module.exports = {"error":"error-boundary_error__1geMr","errorTitle":"error-boundary_errorTitle__o5yW4","button":"error-boundary_button__QZPbi"};